export const iotconnectorstext = {
    name: "Nom",
    servertype: "Type de serveur",
    group: "Compte client",
    organizationid: "Identifiant sur le serveur",
    status: "Statut",
    nameonserver: "Nom sur le serveur",
    dirpath: "Chemin sur le serveur",
    filesregex: "Regex des fichiers à récupérer",
    username: "Nom d'utilisateur",
    password:"Mot de passe",
    ipaddress : "Adresse du serveur",
    port: "Port du serveur",
    protocole: "Protocole",
    prefix: "Préfixe à donner aux fichiers"
}